import styled from "styled-components";

export const StyledTableItemLink = styled.div`
	display: flex;
	flex-direction: column;
	gap: 4px;
	& a {
		color: var(--color-blue);
		cursor: pointer;
		text-decoration: underline;
		margin: 0;
	}
`;
